export const getTranslationLanguageCode = (languageCode) => {
  const fullCodeList = ["zh-tw", "pt-pt"];
  if (fullCodeList.includes(languageCode)) return languageCode;

  const dashIndex = languageCode.indexOf("-");
  return dashIndex === -1 ? languageCode : languageCode.slice(0, dashIndex);
};
